import React from "react";
import { useOutlet } from "react-router";

export const ReferenceDataConfiguration = () => {
  const outlet = useOutlet();
  return <>{outlet || <h4>Import reference data</h4>}</>;
};
